module.exports = __webpack_public_path__ + "static/media/f772d3d7eddcf3c84f710c10999479f0.f772d3d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/f772d3d7eddcf3c84f710c10999479f0.svg
// module id = 1082
// module chunks = 21